import { render, staticRenderFns } from "./WPButtonMenu.vue?vue&type=template&id=11e20310"
import script from "./WPButtonMenu.vue?vue&type=script&lang=ts"
export * from "./WPButtonMenu.vue?vue&type=script&lang=ts"
import style0 from "./WPButtonMenu.vue?vue&type=style&index=0&id=11e20310&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports